import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {API_MAP} from '../../../core/helpers/api.map';
import {map} from 'rxjs';
import {AboutService} from './about.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const aboutResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AboutService)
    .get(API_MAP.about + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};

